// frontend/src/components/Chatbot/PendingActionsPanel.tsx
// Presentational component for pending action confirmations and action results.

import PendingActions, { type ActionLike, type ExecutedAction, type BlockedAction } from './PendingActions';
import ActionResultsDisplay from './ActionResultsDisplay';

export interface PendingActionsPanelProps {
  pendingActions: ActionLike[];
  executedActions: ExecutedAction[];
  blockedActions: BlockedAction[];
  onConfirm: (approvedActions: ActionLike[], rejectedActionIds: string[]) => Promise<void> | void;
  onReject: () => Promise<void> | void;
  isConfirming: boolean;
}

const PendingActionsPanel = ({
  pendingActions,
  executedActions,
  blockedActions,
  onConfirm,
  onReject,
  isConfirming,
}: PendingActionsPanelProps) => {
  const hasPending = pendingActions.length > 0;
  const hasResults = (executedActions.length > 0 || blockedActions.length > 0) && !hasPending;

  if (!hasPending && !hasResults) {
    return null;
  }

  return (
    <>
      {hasPending && (
        <div className="mb-4">
          <PendingActions
            pendingActions={pendingActions}
            onConfirm={onConfirm}
            onReject={onReject}
            isProcessing={isConfirming}
          />
        </div>
      )}

      {hasResults && (
        <div className="mb-4">
          <ActionResultsDisplay
            executedActions={executedActions}
            blockedActions={blockedActions}
            collapsible={true}
            defaultCollapsed={false}
          />
        </div>
      )}
    </>
  );
};

export default PendingActionsPanel;
